import PropTypes from 'prop-types'
import React from 'react'
import content from 'pp-react-l10n'
import { Checkbox } from '@paypalcorp/pp-react-checkbox'
const i18n = content('transfer/page/preview')

const STYLES = {
  checkbox: {
    textAlign: 'center',
  },
}

class PurchaseConsentCheckbox extends React.Component {
  static propTypes = {
    containerStyle: PropTypes.object,
    handleChangePurchaseConsentCheckbox: PropTypes.func.isRequired,
    isPurchaseConsentChecked: PropTypes.bool.isRequired,
    purchaseConsentLabelText: PropTypes.string.isRequired,
    hasPurchaseConsentError: PropTypes.bool.isRequired,
  }

  handleChange = e => {
    this.props.handleChangePurchaseConsentCheckbox(e.target.checked)
  }

  renderPurchaseConsentCheckbox = () => {
    const {
      isPurchaseConsentChecked,
      containerStyle,
      purchaseConsentLabelText,
      hasPurchaseConsentError,
    } = this.props
    const errorProps = hasPurchaseConsentError
      ? {
          error: true,
          errorText: i18n.html('error.purchaseConsent') || '',
        }
      : null
    return (
      <React.Fragment>
        <div className="purchaseConsentCheckboxWrapper" style={containerStyle}>
          <Checkbox
            id="purchaseConsentCheckbox"
            name="purchaseConsent"
            onChange={this.handleChange}
            checked={isPurchaseConsentChecked}
            label={purchaseConsentLabelText}
            {...errorProps}
            style={STYLES.div}
          />
        </div>
      </React.Fragment>
    )
  }
  render() {
    return <div>{this.renderPurchaseConsentCheckbox()}</div>
  }
}

export default PurchaseConsentCheckbox
